import { useMemo } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../consts";
import { t } from "../../../../services";
import { useDashboardFilterOptions, useSelectedDashboardFilters } from "../../../../hooks";

import { FlexContainers, SmallButton, WrapperContainer } from "../../../../components";
import FiltersList from "./FiltersList";

const DefaultFilters = ({
  isLoading,
  isMarketAdminOnly,

  onUpdateDevice,
  onUpdateMarket,
  onUpdateLocation,
  onUpdatePlatform,
  onUpdateBrowser,
  onUpdateDateRange,
  onSavingFilters,
  onUpdateAppType,
  onUpdateGroup,
  onUpdateConnectivity
}) => {
  const {
    selectedLocation,
    selectedMarkets,
    selectedPlatform,
    selectedBrowser,
    selectedAppType,
    selectedGroup,
    selectedConnectivity
  } = useSelectedDashboardFilters();

  const { locationOptions } = useDashboardFilterOptions();

  const isButtonDisabled = useMemo(() => {
    return (
      (selectedMarkets && !selectedMarkets?.length) ||
      (selectedLocation &&
        selectedMarkets &&
        !selectedMarkets.some((market) => market.id === 0) &&
        !selectedLocation?.length &&
        locationOptions.length !== 0) ||
      (selectedPlatform && !selectedPlatform?.length) ||
      (selectedBrowser && !selectedBrowser?.length) ||
      (selectedAppType && !selectedAppType?.length) ||
      (selectedGroup && !selectedGroup?.length) ||
      (selectedConnectivity && !selectedConnectivity?.length)
    );
  }, [
    selectedMarkets,
    selectedLocation,
    selectedPlatform,
    selectedBrowser,
    selectedAppType,
    selectedGroup,
    selectedConnectivity
  ]);

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnCenter} width="100%" mt={32}>
      <FiltersList
        isLoading={isLoading}
        isMarketAdminOnly={isMarketAdminOnly}
        onUpdateDateRange={onUpdateDateRange}
        onUpdateMarket={onUpdateMarket}
        onUpdateBrowser={onUpdateBrowser}
        onUpdateLocation={onUpdateLocation}
        onUpdateDevice={onUpdateDevice}
        onUpdatePlatform={onUpdatePlatform}
        onUpdateAppType={onUpdateAppType}
        onUpdateGroup={onUpdateGroup}
        onUpdateConnectivity={onUpdateConnectivity}
      />

      <WrapperContainer Container={FlexContainers.FlexColumn} width={298} mt={32}>
        <SmallButton onClick={onSavingFilters} disabled={isButtonDisabled} fullWidth>
          {t(strCode.SHOW_DASHBOARD)}
        </SmallButton>
      </WrapperContainer>
    </WrapperContainer>
  );
};

DefaultFilters.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isMarketAdminOnly: PropTypes.bool.isRequired,

  onUpdateDevice: PropTypes.func.isRequired,
  onUpdateMarket: PropTypes.func.isRequired,
  onUpdateLocation: PropTypes.func.isRequired,
  onUpdatePlatform: PropTypes.func.isRequired,
  onUpdateBrowser: PropTypes.func.isRequired,
  onUpdateDateRange: PropTypes.func.isRequired,
  onSavingFilters: PropTypes.func.isRequired,
  onUpdateAppType: PropTypes.func.isRequired,
  onUpdateGroup: PropTypes.func.isRequired,
  onUpdateConnectivity: PropTypes.func.isRequired
};

export default DefaultFilters;
